import React from "react";
import { CustomButton } from "@/components/ui/Buttons";
import ProgressIndicator from "./ProgressIndicator";
import { useProfileCompletion } from "@/hooks/useProfileCompletion";
import { TUser } from "@/types/types";
import { Link } from "react-router-dom";

const ProfileCompletionBanner = ({ data }: { data: TUser }) => {
  const { totalProfileCompletion, isProfileComplete } =
    useProfileCompletion(data);

  return (
    <div className="mt-[22px] p-4 rounded-xl bg-[#F7FAFF] border border-[#17457D1A]">
      <div className="flex justify-between gap-8">
        {/* Left Content */}
        <div>
          <h3 className="text-sm leading-[22px] tracking-[-1%] font-medium mb-3">
            Complete the Profile
          </h3>
          <p className="text-sm leading-5 tracking-[-1%] text-[#667085]">
            {isProfileComplete
              ? "Your profile is complete!"
              : "Build the Profile to access more opportunities"}
          </p>
          <div className="mt-2.5 md:hidden">
            <ProgressIndicator used={totalProfileCompletion} total={100} />
          </div>

          <Link to={"/profile"}>
            <CustomButton
              variant="outline"
              color="#000000"
              fontSize="14px"
              fontWeight="500"
              border="1px solid #475467"
              borderRadius="100px"
              padding="10px 24px"
              className="leading-5 tracking-[-1%] mt-3.5 md:mt-6"
            >
              {isProfileComplete ? "View Profile" : "Complete Profile"}
            </CustomButton>
          </Link>
        </div>

        {/* Right Content */}
        <div className="md:block hidden">
          <ProgressIndicator used={totalProfileCompletion} total={100} />
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionBanner;
